import { putRequest } from './authHttpClient';
import { config } from '../utils/apiConfig';


export const markBonusAsRead = async (notificationId) => {
  const resourceUrl = `${config.API_URL}/userNotification/${notificationId}`;
  const result = await putRequest(resourceUrl,{},)
  return result.data;
};
